/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
  // {
  //   url: "/apps/email",
  //   name: "Email",
  //   slug: "email",
  //   icon: "MailIcon",
  //   i18n: "Email",
  // },
  /* {
    url: null,
    name: 'Dashboard',
    tag: '2',
    tagColor: 'warning',  
    icon: 'HomeIcon',
    i18n: 'Dashboard',
    submenu: [
      {
        url: '/dashboard/analytics',
        name: 'Analytics',
        slug: 'dashboard-analytics',
        i18n: 'Analytics'
      },
      {
        url: '/dashboard/ecommerce',
        name: 'eCommerce',
        slug: 'dashboard-ecommerce',
        i18n: 'eCommerce'
      }
    ]
  }, */
  {
    header: 'Apps',
    icon: 'PackageIcon',
    i18n: 'Dashboard',
    items: [
      {
        url: '/dashboard/dashboard',
        name: 'Dashboard',
        slug: 'dashboard',
        icon: 'LayoutIcon',
        i18n: 'Dashboard'
      },
      {
        url: '/pages/cms/landing',
        name: 'Landing',
        slug: 'landing',
        icon: 'HomeIcon',
        i18n: 'Landing'
      },
      // {
      //   url: null,
      //   name: 'Orders',
      //   icon: 'PackageIcon',
      //   i18n: 'Orders',
      //   submenu: [
      //     {
      //       url: '/pages/orders/view-orders',
      //       name: 'Orders',
      //       slug: 'orders',
      //       i18n: 'View-Orders'
      //     }
      //   ]
      // },
      // {
      //   url: null,
      //   name: 'Products',
      //   icon: 'ShoppingCartIcon',
      //   i18n: 'Products',
      //   submenu: [
      //     {
      //       url: '/pages/products/all-products',
      //       name: 'All-Products',
      //       slug: 'all-products',
      //       i18n: 'All-Products'
      //     },
      //     {
      //       url: '/pages/products/inventory',
      //       name: 'Inventory',
      //       slug: 'inventory',
      //       i18n: 'Inventory'
      //     },
      //     {
      //       url: '/pages/products/category-tag',
      //       name: 'Category & Tag',
      //       slug: 'category-tag',
      //       i18n: 'Category & Tag'
      //     },
      //     {
      //       url: '/pages/products/coupons',
      //       name: 'Coupons',
      //       slug: 'coupons',
      //       i18n: 'Coupons'
      //     }
      //   ]
      // },
      /*{
        url: '/pages/customers/customers',
        name: 'Customers',
        slug: 'customers',
        icon: 'UserIcon',
        i18n: 'Customers'
      },*/
      {
        url: null,
        name: 'Courses',
        slug: 'courses',
        icon: 'VideoIcon',
        i18n: 'Courses',
        submenu: [
          {
            url: '/pages/courses/coursesList',
            name: 'Courses List',
            slug: 'courses-list',
            i18n: 'Courses List'
          },
          {
            url: '/pages/courses/videoLibrary',
            name: 'Video Library',
            slug: 'video-library',
            i18n: 'Video Library'
          }
        ]
      },
      // {
      //   url: null,
      //   name: 'Blogs',
      //   slug: 'blogs',
      //   icon: 'EditIcon',
      //   i18n: 'Blogs',
      //   submenu: [
      //     {
      //       url: '/pages/blogs/blogsList',
      //       name: 'Blogs List',
      //       slug: 'blogs-list',
      //       i18n: 'Blogs List'
      //     }
      //   ]
      // },
      {
        url: null,
        name: 'Reports',
        icon: 'EditIcon',
        i18n: 'Reports',
        submenu: [
          {
            url: '/pages/reports/courses',
            name: 'Courses',
            slug: 'courses',
            i18n: 'Courses'
          },
          {
            url: '/pages/reports/users',
            name: 'Users',
            slug: 'users',
            i18n: 'Users'
          }
        ]
      },
      {
        url: '/pages/UserManagement',
        name: 'User Management',
        slug: 'User Management',
        icon: 'PackageIcon',
        i18n: 'User Management'
      }
      /*{
        url: '/pages/todo',
        name: 'Todo',
        slug: 'todo',
        icon: 'CheckSquareIcon',
        i18n: 'Todo'
      }*/
    ]
  }
]
